function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0323 12.3484C14.0323 10.6951 15.3725 9.35484 17.0258 9.35484H25.071C26.7243 9.35484 28.0645 10.6951 28.0645 12.3484V25.071C28.0645 26.7243 26.7243 28.0645 25.071 28.0645H17.0258C15.3725 28.0645 14.0323 26.7243 14.0323 25.071V12.3484Z",
  fill: "url(#paint0_radial)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M45.6516 14.0323C47.3049 14.0323 48.6452 15.3725 48.6452 17.0258V25.071C48.6452 26.7243 47.3049 28.0645 45.6516 28.0645H32.929C31.2757 28.0645 29.9355 26.7243 29.9355 25.071V17.0258C29.9355 15.3725 31.2757 14.0323 32.929 14.0323L45.6516 14.0323Z",
  fill: "url(#paint1_radial)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.071 29.9355C26.7243 29.9355 28.0645 31.2757 28.0645 32.929V40.9742C28.0645 42.6275 26.7243 43.9677 25.071 43.9677H12.3484C10.6951 43.9677 9.35484 42.6275 9.35484 40.9742V32.929C9.35484 31.2757 10.6951 29.9355 12.3484 29.9355H25.071Z",
  fill: "url(#paint2_radial)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.9677 45.6516C43.9677 47.3049 42.6275 48.6452 40.9742 48.6452H32.929C31.2757 48.6452 29.9355 47.3049 29.9355 45.6516L29.9355 32.929C29.9355 31.2757 31.2757 29.9355 32.929 29.9355H40.9742C42.6275 29.9355 43.9677 31.2757 43.9677 32.929L43.9677 45.6516Z",
  fill: "url(#paint3_radial)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M58 21.1419C58 23.2085 56.3247 24.8839 54.2581 24.8839C52.1915 24.8839 50.5161 23.2085 50.5161 21.1419C50.5161 19.0753 52.1915 17.4 54.2581 17.4C56.3247 17.4 58 19.0753 58 21.1419Z",
  fill: "url(#paint4_radial)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8839 3.74194C24.8839 5.80855 23.2085 7.48387 21.1419 7.48387C19.0753 7.48387 17.4 5.80855 17.4 3.74194C17.4 1.67532 19.0753 0 21.1419 0C23.2085 0 24.8839 1.67532 24.8839 3.74194Z",
  fill: "url(#paint5_radial)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40.7871 54.2581C40.7871 56.3247 39.1118 58 37.0452 58C34.9785 58 33.3032 56.3247 33.3032 54.2581C33.3032 52.1915 34.9785 50.5161 37.0452 50.5161C39.1118 50.5161 40.7871 52.1915 40.7871 54.2581Z",
  fill: "url(#paint6_radial)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.48387 37.0452C7.48387 39.1118 5.80855 40.7871 3.74194 40.7871C1.67532 40.7871 0 39.1118 0 37.0452C0 34.9785 1.67532 33.3032 3.74194 33.3032C5.80855 33.3032 7.48387 34.9785 7.48387 37.0452Z",
  fill: "url(#paint7_radial)"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 29) rotate(90) scale(46.6806)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 29) rotate(90) scale(46.6806)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 29) rotate(90) scale(46.6806)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 29) rotate(90) scale(46.6806)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 29) rotate(90) scale(46.6806)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 29) rotate(90) scale(46.6806)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 29) rotate(90) scale(46.6806)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 29) rotate(90) scale(46.6806)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4116"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F56139"
})));

function SvgEmptyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLogo);
export default __webpack_public_path__ + "static/media/emptyLogo.9f910594.svg";
export { ForwardRef as ReactComponent };